import { put, takeEvery } from "redux-saga/effects";
import _ from 'lodash';
import history from '../../../history';
import { types } from "../../Types/register";
import { toast } from "react-toastify";
import { registerApi } from "./api";

type SagaGenerator<T = any> = Generator<any, T, any>;

function* registerUser(action: any): SagaGenerator<void> {
  try {
    const result = yield registerApi(action.payload);
    yield put({ type: types.REGISTRATION_SUCCESS, payload: result.message });
    history.push("/");
    toast.info("Signup was successfull, Please Verify your email", {
      autoClose: 10000
    });
  } catch (error: any) {
    if (error.name === 'UsernameExistsException') {
      yield put({type: types.REGISTRATION_FAILURE});
      toast.error('Please sign in to continue.');
    } else if (error.name === 'InvalidPasswordException') {
      yield put({type: types.REGISTRATION_FAILURE});
      toast.error('The provided password is invalid.');
    } else if (_.has(error, 'response') && _.has(error.response, 'status') && error.response.status === 303) {
      yield put({ type: types.REGISTRATION_FAILURE });
      toast.error(error.response.data.message);
    } else {
      yield put({ type: types.REGISTRATION_FAILURE });
      const message = error?.response?.data?.message || "Error, Please try again";
      toast.error(message);
    }
  }
}
export function* registerhWatcher(): SagaGenerator<void> {
  yield takeEvery(types.REGISTRATION_REQUEST, registerUser);
}
